import * as yup from 'yup'
import { hasNondriverUserType } from 'utils/teamMemberHelpers'
import {
  IMotorCarrierDetail,
  ITeamMember,
  TEAM_MEMBER_ROLE_TYPES,
  TEAM_MEMBER_USER_TYPES,
} from '../types'

const MotorCarrierDetailsSchema = yup.object<IMotorCarrierDetail>().shape({
  motorCarrierId: yup.number(),
  checked: yup.boolean().default(false),
  role: yup.mixed().when('checked', {
    is: true,
    then: yup.mixed<TEAM_MEMBER_ROLE_TYPES>().required('Please select an option'),
    otherwise: yup.mixed().notRequired(),
  }),
  userType: yup.mixed().when('checked', {
    is: true,
    then: yup.mixed<TEAM_MEMBER_USER_TYPES>().required('Please select an option'),
    otherwise: yup.mixed().notRequired(),
  }),
})

export const TeamMemberModalSchema = yup.object<ITeamMember>().shape({
  motorCarrierDetails: yup.array().of(MotorCarrierDetailsSchema).ensure(),
  firstName: yup.string().required('Please enter a first name.'),
  lastName: yup.string().required('Please enter a last name.'),
  phone: yup.string().when('motorCarrierDetails', {
    is: mcd => hasNondriverUserType(mcd),
    then: yup
      .string()
      .required('Please enter a phone number.')
      .test('len', 'Please enter a valid phone number.', val => val?.length === 10),
    otherwise: yup.string().notRequired(),
  }),
  email: yup.string().when('motorCarrierDetails', {
    is: mcd => hasNondriverUserType(mcd),
    then: yup.string().email().required('Please enter an email.'),
    otherwise: yup.string().email('Please enter a valid email.'),
  }),
  cellPhone: yup
    .string()
    .required('Please enter a mobile phone number.')
    .test('len', 'Please enter a valid mobile phone number.', val => val.length === 10),
  smsStatusUpdatesEnabled: yup.boolean().required().default(false),
})
export type TeamMemberModalSchemaType = yup.InferType<typeof TeamMemberModalSchema>
export type MotorCarrierDetailsSchemaType = yup.InferType<typeof MotorCarrierDetailsSchema>
